import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import NumberInput from '../../../../common/input/NumberInput';
import useCalculatorForOtherBankCondition from '../../../../../hooks/estimate/common/otherBank/useCalculatorForOtherBankCondition';
import { otherBankInfoState } from '../../../../../data/estimate/common/otherBank/info/selector';

interface Props {
  isDisabled: boolean;
}

/**
 *  타금융사 할부조건 인도-탁송 직접입력 로직 컴포넌트
 * @param {boolean} isDisabled 비활성화 여부
 *  */
function OtherBankDeliveryMoneyWithoutConsignmentPrice({ isDisabled }: Props): JSX.Element {
  // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
  const [input, setInput] = useState<number>(0);

  // selected
  const value: number = useRecoilValue(
    otherBankInfoState({ name: 'otherBankDeliveryMoneyWithoutConsignmentPrice' })
  );

  // function
  const { updateInstallment } = useCalculatorForOtherBankCondition();
  const onBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const deliveryMoneyWithoutConsignmentPrice: number = Number(e.target.value);
    updateInstallment({
      inputName: 'deliveryMoneyWithoutConsignmentPrice',
      inputValue: deliveryMoneyWithoutConsignmentPrice,
    });
    setInput(deliveryMoneyWithoutConsignmentPrice);
  };

  useEffect(() => {
    // state 추가한 이유는 산출후에 가격이 계속 같지만 input의 state는 계속 변동되기 때문에 실제 value와 input의 state의 sync가 안맞아 sync를 맞추기 위한 리렌더링 발생을 위해 추가함
    input !== value && setInput(value);
  }, [input, value]);

  return (
    <NumberInput
      width='70px'
      fontSize='10px'
      name='deliveryMoneyWithoutConsignmentPrice'
      value={Math.round(input)}
      onBlur={onBlur}
      disabled={isDisabled}
    />
  );
}

export default OtherBankDeliveryMoneyWithoutConsignmentPrice;
